module.exports = " <div class=vux-button-group> <slot></slot> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/button-tab/button-tab.vue
// module id = 205
// module chunks = 2